// extracted by mini-css-extract-plugin
export var buttonContainer = "_5j-1";
export var fontSizeSelect = "_5j-3";
export var formatSelect = "_5j-2";
export var formats = "_5j-4";
export var hidden = "_5j-5";
export var icon = "_5j-6";
export var select = "_5j-0";